import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetch2FAQr = createAsyncThunk(
    'twoFA/fetchQr',
    async ({ email }, { rejectWithValue }) => {
        try {
            const res = await axios.get(process.env.REACT_APP_API_BASE_URL + '/api/auth/2fa/enable' + `?email=${email}`);
            return res?.data?.data?.qrCode;
        } catch (err) {
            return rejectWithValue('Failed to load QR Code');
        }
    }
);

export const verify2FA = createAsyncThunk(
    'twoFA/verify',
    async ({ token, email, password }, { rejectWithValue }) => {
        try {
            const res = await axios.post(process.env.REACT_APP_API_BASE_URL + '/api/auth/2fa/verify', { token, email, password });
            return res.data;
        } catch (err) {
            return rejectWithValue('Invalid verification code');
        }
    }
);

export const sendMagicLink = createAsyncThunk(
    'twoFA/sendMagicLink',
    async ({ email }, { rejectWithValue }) => {
        try {
            const res = await axios.post(process.env.REACT_APP_API_BASE_URL + '/api/auth/2fa/magic-link', { email });
            return res.data;
        } catch (err) {
            return rejectWithValue('Unable to send magic link');
        }
    }
);

export const verifyMagicLink = createAsyncThunk(
    'twoFA/verifyMagicLink',
    async ({ token }, { rejectWithValue }) => {
        try {
            const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/api/auth/2fa/verify/magic-link?token=${token}`);
            return res.data;
        } catch (err) {
            return rejectWithValue('Invalid Token');
        }
    }
);

export const verifyBackupCode = createAsyncThunk(
    'twoFA/verifyBackupCode',
    async ({ email, password, code }, { rejectWithValue }) => {
        try {
            const res = await axios.post(process.env.REACT_APP_API_BASE_URL + `/api/auth/2fa/backup-codes/login`, { email, password, code });
            return res.data;
        } catch (err) {
            return rejectWithValue('Invalid backup code');
        }
    }
);

const initialState = {
    qrCode: null,
    loading: false,
    verified: false,
    error: null,
};

const twoFASlice = createSlice({
    name: 'twoFA',
    initialState,
    reducers: {
        reset2FAState: (state) => {
            state.qrCode = null;
            state.verified = false;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetch2FAQr.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetch2FAQr.fulfilled, (state, action) => {
                state.loading = false;
                state.qrCode = action.payload;
            })
            .addCase(fetch2FAQr.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(verify2FA.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verify2FA.fulfilled, (state) => {
                state.loading = false;
                state.verified = true;
            })
            .addCase(verify2FA.rejected, (state, action) => {
                state.loading = false;
                state.verified = false;
                state.error = action.payload;
            })

            .addCase(sendMagicLink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendMagicLink.fulfilled, (state) => {
                state.loading = false;
                state.verified = true;
            })
            .addCase(sendMagicLink.rejected, (state, action) => {
                state.loading = false;
                state.verified = false;
                state.error = action.payload;
            })

            .addCase(verifyMagicLink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyMagicLink.fulfilled, (state) => {
                state.loading = false;
                state.verified = true;
            })
            .addCase(verifyMagicLink.rejected, (state, action) => {
                state.loading = false;
                state.verified = false;
                state.error = action.payload;
            })

            .addCase(verifyBackupCode.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyBackupCode.fulfilled, (state) => {
                state.loading = false;
                state.verified = true;
            })
            .addCase(verifyBackupCode.rejected, (state, action) => {
                state.loading = false;
                state.verified = false;
                state.error = action.payload;
            });
    },
});

export const { reset2FAState } = twoFASlice.actions;

export const select2FA = (state) => state.twoFA;

export default twoFASlice.reducer;
